import {
  Collapse,
  Group,
  Paper,
  Text,
  UnstyledButton,
} from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface FarmerInfoProps {
  organizationName?: string;
  projectName?: string;
  farmName?: string;
  collapsible?: boolean;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

export const FarmerInfo: FC<FarmerInfoProps> = ({
  organizationName,
  projectName,
  farmName,
  collapsible = false,
  expanded = true,
  onExpandedChange,
}) => {
  const { t } = useTranslation();

  const content = (
    <>
      <Text size="lg">
        {t('common.societe')} : {farmName}
      </Text>
      <Text mt="md" size="lg">
        {t('common.bonjour')},
      </Text>
      <Text mt="md" size="lg">
        {t('farmer-validation.info-intro', {
          organizationName,
          projectName,
        })}
      </Text>
    </>
  );

  if (!collapsible) {
    return <Paper p="md">{content}</Paper>;
  }

  return (
    <Paper p="md">
      <UnstyledButton
        aria-expanded={expanded}
        onClick={() => onExpandedChange?.(!expanded)}
        type="button"
        w="100%"
      >
        <Group justify="space-between" wrap="nowrap">
          <Text fw={600} size="sm">
            {expanded
              ? t('farmer-validation.info-toggle-collapse')
              : t('farmer-validation.info-toggle-expand')}
            {farmName ? ` — ${farmName}` : ''}
          </Text>
          {expanded ? (
            <IconChevronUp aria-hidden size={18} stroke={1.5} />
          ) : (
            <IconChevronDown aria-hidden size={18} stroke={1.5} />
          )}
        </Group>
      </UnstyledButton>
      <Collapse in={expanded}>
        <div style={{ marginTop: 'var(--mantine-spacing-md)' }}>{content}</div>
      </Collapse>
    </Paper>
  );
};
